import { render, staticRenderFns } from "./EditDataPumkm.vue?vue&type=template&id=712b9a44&scoped=true&"
import script from "./EditDataPumkm.vue?vue&type=script&lang=js&"
export * from "./EditDataPumkm.vue?vue&type=script&lang=js&"
import style0 from "./EditDataPumkm.vue?vue&type=style&index=0&id=712b9a44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712b9a44",
  null
  
)

export default component.exports